import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})

export class CreditNoteService {

  constructor(private api: ApiService) {}

  saleCustomerlist(): Observable<any> {
    return this.api.post('CreditNote/saleCustomerlist');
  }

  getCreditNoteNo(): Observable<any> {
    return this.api.post('CreditNote/getCreditNoteNo');
  }

  searchInvoice(term: string, customer_id: any) {
    if (term == '' || term.length <= 2) {
      return of([]);
    }

    return this.api.post('CreditNote/listInvoiceNo', {
      search_text: term,
      start: 0,
      limit: 10,
      customer_id: customer_id
    });
  }

  saveCreditNote(opData: any): Observable<any> {
    return this.api.post('CreditNote/saveCreditNote', opData);
  }

  getCreditNoteList(opData: any): Observable<any> {
    return this.api.post('CreditNote/getCreditNoteList', opData);
  }

  getCreditNote(opData: any): Observable<any> {
    return this.api.post('CreditNote/getCreditNote', opData);
  }

  deleteCreditNote(opData: any): Observable<any> {
    return this.api.post('CreditNote/deleteCreditNote', opData);
  }

}
